/**
 * initialiser that checks for nestedListItems and parses them when the function is called
 */
window.parseNestedLists = function() {
    let nestedListItems = document.querySelectorAll('.nestedList');

    if (nestedListItems){
        nestedListItems.forEach((nestedItem) => {
            let content = JSON.parse(nestedItem.dataset.attribute);
            let result = nestedJsonDataParser(content);
            nestedItem.append(result);
        });
    }
}

/**
 * parser that converts json nested lists into html that can be used for the end-result
 * @param element
 * @returns {HTMLUListElement}
 */
window.nestedJsonDataParser = function (element) {
    const ul = document.createElement('ul');
    element.data.items.forEach(item => {
        const li = document.createElement('li');
        li.textContent = item.content;
        if (item.items.length > 0) {
            li.appendChild(nestedJsonDataParser({ data: { items: item.items } }));
        }
        ul.appendChild(li);
    });
    return ul;
}

